@if (!categoryStore.asArray().length) {
  <app-alert header="Keine Indikatoren-Bereiche vorhanden" [canToggle]="false">
    Legen Sie zuerst Indikatoren-Bereiche über das
    <a
      [routerLink]="[
        '/data-backend',
        {
          outlets: {
            overlay: [
              'neu',
              { outlets: { panel: ['indikatoren-bereich', 'neu'] } },
            ],
          },
        },
      ]"
      >Formular</a
    >
    an.
  </app-alert>
  <p-divider />
}

<div *ngIf="!categoryStep">
  <app-pool-filter></app-pool-filter>
  <div class="grid">
    <div class="col-12">
      <p-pickList
        class="app-pick-list"
        [source]="sourceList()"
        [target]="selected()"
        (onMoveToTarget)="addToSelection($event)"
        (onMoveAllToTarget)="addToSelection($event)"
        (onMoveToSource)="removeFromSelection($event)"
        (onMoveAllToSource)="removeFromSelection($event)"
        (onTargetReorder)="onTargetReorder()"
        [dragdrop]="true"
        [responsive]="true"
        [showSourceControls]="false"
        [showTargetControls]="true"
        [sourceStyle]="{ height: '30rem' }"
        [targetStyle]="{ height: '30rem' }"
        breakpoint="1400px">
        <ng-template pTemplate="sourceHeader">
          <app-pick-list-header
            title="Vorlagen"
            [count]="sourceList().length" />
        </ng-template>
        <ng-template pTemplate="targetHeader">
          <app-pick-list-header
            title="Auswahl"
            [count]="selected().length"
            subtitle="Diese Indikatoren werden Ihrem Indikatorenverzeichnis hinzugefügt – in dieser Reihenfolge." />
        </ng-template>
        <ng-template let-indicator pTemplate="item">
          <p-contextMenu
            [target]="cm"
            [model]="contextMenu"
            appendTo="body"></p-contextMenu>
          <div
            #cm
            class="pl-row"
            pTooltip="Rechtsklick für weitere Informationen"
            [showDelay]="1000"
            (contextmenu)="onContextMenuOpen($event, indicator)">
            <i
              class="fas pl-icon"
              [ngClass]="
                indicator.isSet ? 'fa-layer-group' : 'fa-ruler-vertical'
              "></i>
            <div class="pl-body">
              <span class="pl-name">{{ indicator.name }}</span>
              <span class="pl-meta">
                @if (indicator.tags | tagSummary; as tags) {
                  @if (tags.shown) {
                    <span
                      class="pl-meta-item"
                      [pTooltip]="tags.rest ? tags.all : undefined">
                      <i class="fas fa-tag pl-meta-icon"></i>
                      {{ tags.shown }}
                      @if (tags.rest) {
                        +{{ tags.rest }}
                      }
                    </span>
                  }
                }
                @if (indicator.products | tagSummary; as products) {
                  @if (products.shown) {
                    <span class="pl-meta-item pl-warning">
                      <i class="fas fa-box pl-meta-icon"></i>
                      {{ products.shown }}
                      @if (products.rest) {
                        +{{ products.rest }}
                      }
                    </span>
                  }
                }
              </span>
            </div>
            @if (indicator.isSet) {
              <span class="pl-pill">{{ poolChildCount(indicator) }}</span>
            }
            <span class="pl-end">{{
              units[indicator.unit]?.symbol || units[indicator.unit]?.name
            }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessagesource">
          <div class="pl-empty">Keine weiteren Vorlagen.</div>
        </ng-template>
        <ng-template pTemplate="emptymessagetarget">
          <div class="pl-empty">
            Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen
            übernehmen.
          </div>
        </ng-template>
      </p-pickList>
    </div>
  </div>

  <p-divider></p-divider>
  <footer class="flex align-items-center gap-3">
    <p-button
      [disabled]="selected().length === 0"
      class="ml-auto"
      label="hinzufügen"
      icon="fas fa-check-circle"
      [rounded]="true"
      (click)="selectForCopy()"></p-button>
  </footer>
</div>

<p-sidebar
  [(visible)]="displayIndicatorDetails"
  [styleClass]="'w-6'"
  position="right"
  [modal]="true"
  appendTo="body"
  (onHide)="closeOverlay()">
  <app-indicator-detail [indicator]="indicatorToShow" />
</p-sidebar>

@if (categoryStep) {
  <div class="grid">
    <div class="col-12">
      <app-header
        icon="fas fa-folder-open"
        sub="In welchen Ordner sollen die Indikatoren kopiert werden?"
        text="Ordner auswählen"></app-header>
      <app-category-tree
        (categorySelection)="
          copyIndicatorConfirmation($event)
        "></app-category-tree>
    </div>
  </div>
  <p-divider />
  <footer class="flex align-items-center gap-3">
    <p-button
      severity="secondary"
      [rounded]="true"
      [outlined]="true"
      icon="fas fa-xmark"
      (click)="cancel()"
      label="abbrechen"></p-button>
    <p-button
      severity="secondary"
      [rounded]="true"
      [outlined]="true"
      icon="fas fa-arrow-left"
      (click)="back()"
      label="zurück"></p-button>
  </footer>
}

<p-confirmDialog
  key="copyFromPool"
  #cd
  styleClass="w-6"
  appendTo="body"
  [blockScroll]="false">
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header icon="fas fa-copy" [text]="message.header"></app-header>

      <div class="flex">
        Die Indikatoren werden mit den Metainformationen in Ihr
        Indikatorenverzeichnis kopiert. Überprüfen Sie die Metainformationen auf
        die Gültigkeit in Ihrer Kommune.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          severity="success"
          icon="fas fa-check"
          label="Indikatoren übertragen"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
